import { Navigate, useParams } from 'react-router';
import { canonicalPathForListingRef } from '../../utils/itemLinks';

export default function ListingDeepLinkPage() {
  const { itemRef } = useParams();
  return <Navigate to={canonicalPathForListingRef(itemRef)} replace />;
}
